<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>群组控制</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="customer-context" v-loading="customerLoading">
      <div class="customer-context__main">
        <span class="customer-context__label">当前客户</span>
        <span class="customer-context__name">{{ customer.name || '加载中…' }}</span>
      </div>
      <div class="customer-context__meta" v-if="customer.id">
        <span class="customer-context__meta-item">
          <em>编号</em>{{ customer.number || '-' }}
        </span>
        <span class="customer-context__divider"></span>
        <span class="customer-context__meta-item">
          <em>ID</em>{{ customer.id }}
        </span>
      </div>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium">
        <div class="re-el-form__flex">
          <el-form-item v-if="isProjectLevel"
                        label="项目名称"
                        prop="projectid">
            <remote-select
              id-key="number"
              label-key="name"
              value-key="id"
              placeholder="请输入项目名称/编号搜索"
              v-model="search.projectid"
              :query-request="queryProjectForSelect"
              :query-params="{customerid: search.customer_id}"
              :find-request="findProjectForSelect"
              @change="onProjectChange">
            </remote-select>
          </el-form-item>
          <el-form-item label="门店名称/ID"
                        prop="market">
            <remote-select
              label-key="marketname"
              placeholder="请输入门店名称搜索"
              v-model="search.market_id"
              :query-request="getBasicMarketTable"
              :find-request="getBasicMarketDetail"
              clearable>
            </remote-select>
          </el-form-item>
          <el-form-item label="群组名称"
                        prop="group">
            <el-input placeholder="请输入群组名称"
                      clearable
                      v-model="search.group"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="onSearch()">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <div class="margin b15">
        <el-button size="mini"
                   type="primary"
                   icon="el-icon-folder-add"
                   @click="displayCreateMarketGroupDialog(null)"> 新增
        </el-button>
        <el-button size="mini"
                   type="primary"
                   icon="el-icon-download"
                   :disabled="pagination.total <= 0"
                   @click="onExportSearch"> 按搜索结果导出
        </el-button>
        <el-button size="mini"
                   type="primary"
                   icon="el-icon-upload"
                   @click="$router.push(marketUploadPath)"> 批量上传
        </el-button>
        <el-button size="mini"
                   type="danger"
                   icon="el-icon-delete"
                   :disabled="pagination.total <= 0"
                   @click="handleBatchRemoveBtnClicked"> 批量清除全部
        </el-button>
      </div>

      <el-table
        :data="table"
        style="width: 100%">
        <el-table-column
          prop="market_name"
          label="门店名称/ID"
          min-width="240">
          <template slot-scope="scope">
            {{scope.row.market_name}} / {{scope.row.market_id}}
          </template>
        </el-table-column>
        <el-table-column
          prop="sales_name"
          label="群组名称1"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="sales_name2"
          label="群组名称2"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="sales_name3"
          label="群组名称3"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="sales_name4"
          label="群组名称4"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="sales_name5"
          label="群组名称5"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          min-width="160">
        </el-table-column>
        <el-table-column
          prop="updated_at"
          label="更新时间"
          min-width="160">
        </el-table-column>
        <el-table-column
          prop=""
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="mini"
                       @click="displayCreateMarketGroupDialog(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination margin t10">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[10, 20, 30, 50]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <el-dialog
      :title="createDialog.title"
      :before-close="onCloseCreateGroupMarketDialog"
      :visible.sync="showCreateGroupMarketDialog">
      <el-form :model="createForm" ref="createForm" :rules="createFormRules">
        <el-form-item label="门店名称/ID" prop="market_id" label-width="120px">
          <remote-select
            label-key="marketname"
            placeholder="请输入门店名称搜索"
            v-model="createForm.market_id"
            :query-request="getBasicMarketTable"
            :find-request="getBasicMarketDetail"
            clearable>
          </remote-select>
        </el-form-item>
        <el-form-item label="群组名称1" prop="sales_name" label-width="120px">
          <el-input placeholder="请输入" v-model="createForm.sales_name" clearable></el-input>
        </el-form-item>
        <el-form-item label="群组名称2" prop="sales_name2" label-width="120px">
          <el-input placeholder="请输入（选填）" v-model="createForm.sales_name2" clearable></el-input>
        </el-form-item>
        <el-form-item label="群组名称3" prop="sales_name3" label-width="120px">
          <el-input placeholder="请输入（选填）" v-model="createForm.sales_name3" clearable></el-input>
        </el-form-item>
        <el-form-item label="群组名称4" prop="sales_name4" label-width="120px">
          <el-input placeholder="请输入（选填）" v-model="createForm.sales_name4" clearable></el-input>
        </el-form-item>
        <el-form-item label="群组名称5" prop="sales_name5" label-width="120px">
          <el-input placeholder="请输入（选填）" v-model="createForm.sales_name5" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="default" @click="resetForm('createForm')">重置</el-button>
        <el-button type="primary" @click="submitForm('createForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import table from '@core/mixins/table'

const emptyGroupMarketForm = () => ({
  id: null,
  sales_id: null,
  market_id: null,
  sales_name: '',
  market_name: null,
  sales_id2: null,
  sales_name2: '',
  sales_id3: null,
  sales_name3: '',
  sales_id4: null,
  sales_name4: '',
  sales_id5: null,
  sales_name5: '',
})

export default {
  mixins: [table],
  data () {
    return {
      showCreateGroupMarketDialog: false,
      createDialog: {
        title: null,
        action: null
      },
      createForm: emptyGroupMarketForm(),
      tempGroupMarket: emptyGroupMarketForm(),
      customerLoading: false,
      customer: {
        id: null,
        name: '',
        number: '',
      },
      createFormRules: {
        sales_name: [
          {required: true, message: '请输入群组名称', trigger: 'blur'}
        ],
        market_id: [
          {required: true, message: '请选择门店', trigger: 'blur'}
        ]
      },
      search: {
        customer_id: this.$route.params.customerid,
        projectid: this.$route.params.projectid ? String(this.$route.params.projectid) : '',
        market_id: this.$route.query.market_id,
        group: this.$route.query.group
      },
      searchFieldType: {
        customer_id: Number,
        projectid: Number,
        market_id: Number,
      },
      exportHeader: [
        {
          key: 'market_id',
          text: '门店ID',
        },
        {
          key: 'market_name',
          text: '门店名称',
        },
        {
          key: 'sales_name',
          text: '群组名称1',
        },
        {
          key: 'sales_name2',
          text: '群组名称2',
        },
        {
          key: 'sales_name3',
          text: '群组名称3',
        },
        {
          key: 'sales_name4',
          text: '群组名称4',
        },
        {
          key: 'sales_name5',
          text: '群组名称5',
        },
        {
          key: 'created_at',
          text: '创建时间',
        },
        {
          key: 'updated_at',
          text: '更新时间',
        },
      ],
    }
  },
  created () {
    this.loadCustomer()
  },
  watch: {
    '$route.params.customerid' () {
      this.syncRouteScope()
    },
    '$route.params.projectid' () {
      this.syncRouteScope()
    },
  },
  computed: {
    isProjectLevel () {
      return !!this.$route.params.projectid
    },
    marketUploadPath () {
      if (this.isProjectLevel) {
        return `/group-batch/market-upload-table/${this.search.customer_id}/project/${this.search.projectid}`
      }
      return `/group-batch/market-upload-table/${this.search.customer_id}`
    },
  },
  methods: {
    ...request.map(['getBasicMarketTable', 'getBasicMarketDetail', 'getBasicCustomerDetail', 'getProjectDetail', 'getBaiscProjectTable']),
    normalizeProjectId (item) {
      if (item && item.id != null) {
        item.id = String(item.id)
      }
      return item
    },
    queryProjectForSelect (params) {
      return this.getBaiscProjectTable(params).then((res) => {
        const list = res.data && res.data.data
        if (Array.isArray(list)) {
          list.forEach((item) => this.normalizeProjectId(item))
        }
        return res
      })
    },
    findProjectForSelect (params) {
      return this.getProjectDetail({id: params.id}).then((res) => {
        if (res.data) {
          this.normalizeProjectId(res.data)
        }
        return res
      })
    },
    syncRouteScope () {
      this.search.customer_id = this.$route.params.customerid
      this.search.projectid = this.$route.params.projectid ? String(this.$route.params.projectid) : ''
      this.loadCustomer()
      this.onSearch()
    },
    onProjectChange () {
      const projectId = this.search.projectid ? String(this.search.projectid) : ''
      const routeProjectId = this.$route.params.projectid ? String(this.$route.params.projectid) : ''
      if (!projectId) {
        this.search.projectid = routeProjectId
        return
      }
      if (projectId === routeProjectId) {
        return
      }
      this.$router.push(`/group-batch/market-table/${this.search.customer_id}/project/${projectId}`)
    },
    loadCustomer () {
      const id = this.$route.params.customerid
      if (!id) {
        return
      }
      this.customerLoading = true
      request.common('getBasicCustomerDetail', {id}).then(({data}) => {
        this.customer = {
          id: data.id,
          name: data.name,
          number: data.number,
        }
      }).catch(() => {
        this.customer = {
          id: id,
          name: '客户信息加载失败',
          number: '',
        }
      }).then(() => {
        this.customerLoading = false
      })
    },
    getTableData (params) {
      return request.page('getGroupMarketTable', filter.copyJson(params))
    },
    submitForm (formName, action) {
      const apiName = this.createDialog.action === 1 ? 'createGroupMarket' : 'updateGroupMarket'
      const actionName = this.createDialog.action === 1 ? '新增' : '更新'
      const self = this

      this.$refs[formName].validate((valid) => {
        if (valid) {
          const names = [
            self.createForm.sales_name,
            self.createForm.sales_name2,
            self.createForm.sales_name3,
            self.createForm.sales_name4,
            self.createForm.sales_name5,
          ].map(n => (n || '').trim()).filter(Boolean)
          if (names.length !== new Set(names).size) {
            self.$message.error('群组名称不能重复')
            return
          }

          let requestData = {
            market: self.createForm.market_id,
            group: self.createForm.sales_name,
            group2: self.createForm.sales_name2,
            group3: self.createForm.sales_name3,
            group4: self.createForm.sales_name4,
            group5: self.createForm.sales_name5,
            customer_id: this.search.customer_id,
            projectid: Number(this.search.projectid) || 0,
          }

          if (self.createForm.id) {
            requestData['id'] = self.createForm.id
          }

          request.common(apiName, requestData).then((result) => {
            self.showCreateGroupMarketDialog = false
            self.createForm = emptyGroupMarketForm()
            self.tempGroupMarket = emptyGroupMarketForm()
            self.$message.success(actionName + '成功')
            self.onSearch()
          })
        }
      })
    },
    resetForm (formName) {
      this.createForm = Object.assign({}, this.tempGroupMarket)
    },
    displayCreateMarketGroupDialog (obj) {
      if (!obj) {
        this.createDialog.title = '新增群组门店关系'
        this.createDialog.action = 1
        this.createForm = emptyGroupMarketForm()
        this.tempGroupMarket = emptyGroupMarketForm()
      } else {
        const formData = Object.assign(emptyGroupMarketForm(), obj)

        this.searchMarketResults = [{
          market_id: formData.market_id,
          marketname: formData.market_name
        }]

        this.createDialog.title = '编辑群组门店关系'
        this.createDialog.action = 2
        this.createForm = formData
        this.tempGroupMarket = Object.assign({}, this.createForm)
      }
      this.showCreateGroupMarketDialog = true
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onCloseCreateGroupMarketDialog (done) {
      if (this.createDialog.action === 2) {
        this.tempGroupMarket = emptyGroupMarketForm()
        this.resetForm('createForm')
      } else {
        this.tempGroupMarket = Object.assign({}, this.createForm)
      }
      done()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleBatchRemoveBtnClicked () {
      const scopeLabel = this.isProjectLevel ? '当前项目' : '客户级'
      this.$confirm(`本次清理${scopeLabel}门店关系共${this.pagination.total}条，确认清理吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        request.common('deleteGroupBatchByCustomerId', {
          customer_id: this.$route.params.customerid,
          projectid: Number(this.search.projectid) || 0,
        }).then(() => {
          this.onRefresh()
        })
      })
    }
  }
}
</script>

<style lang="scss">
// 全局CSS
.el-table-column--selection .cell {
  padding-left: 10px !important;
}
</style>

<style lang="scss" scoped>
.customer-context {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 24px;
  margin: 0 0 16px;
  padding: 14px 18px;
  background: #f7f8fa;
  border: 1px solid #ebeef5;
  border-left: 3px solid #409eff;
  border-radius: 4px;
  min-height: 52px;
  box-sizing: border-box;

  &__main {
    display: flex;
    align-items: baseline;
    gap: 10px;
    min-width: 0;
  }

  &__label {
    flex-shrink: 0;
    font-size: 12px;
    color: #909399;
    letter-spacing: 0.02em;
  }

  &__name {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    line-height: 1.3;
    word-break: break-all;
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }

  &__meta-item {
    font-size: 13px;
    color: #606266;
    font-variant-numeric: tabular-nums;

    em {
      font-style: normal;
      margin-right: 6px;
      color: #909399;
      font-size: 12px;
    }
  }

  &__divider {
    width: 1px;
    height: 12px;
    background: #dcdfe6;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/group-batch/pages/GroupBatchMarketTable.vue